import { PriorityStatus } from "@/types";

/** Everything that is not done — done items leave the board. */
export const PEOPLE_ACTIVE_STATUSES: PriorityStatus[] = ["focus", "queue", "blocked", "waiting", "on-hold"];
/** ponytail: one page; paginate/aggregate server-side once the company has >500 open deliverables. */
export const PEOPLE_BOARD_LIMIT = 500;
export const AFTER_VISIBLE = 4;

export type PersonRole = "DRI" | "IC";
export type PersonBucket = "focus" | "queue" | "after";
